import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import React from "react";

const CheckBox = ({ handleChangeCheckBox, declarationMessage, checked }) => {
  return (
    <div style={{ marginTop: "10px" }}>
      <FormGroup>
        <FormControlLabel
          control={<Checkbox checked={checked} onChange={handleChangeCheckBox} inputProps={{ "aria-label": "controlled" }} />}
          label={declarationMessage}
        />
      </FormGroup>
    </div>
  );
};

export default CheckBox;
